module.exports = __webpack_public_path__ + "kite.jpg?8f756df04c7ba05295cce9d5f580ced0";